import styled from 'styled-components';

export const RoutingRuleTitleStyled = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  overflow-x: hidden;
`;

export const DragRule = styled.div`
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  padding: 1px 9px;
`;
